import TickThinOutline from "@assets/svg/TickThinOutline";
// @ts-ignore
import VisaCardImg from "@assets/images/Visa.svg";
// @ts-ignore
import MaestroCardImage from "@assets/images/Maestro.png";
// @ts-ignore
import AmericanExpressCardImg from "@assets/images/AmericanExpress.png";
// @ts-ignore
import MasterCardImg from "@assets/images/MasterCard.png";

interface PaymentCardProps {
  onClick: () => void;
  isSelected: boolean;
  data: any;
}

const PaymentCard = ({ isSelected, onClick, data }: PaymentCardProps) => {
  return (
    <div
      onClick={onClick}
      className={
        isSelected
          ? "border rounded-md p-2.5 cursor-pointer hover:bg-gray-50 border-secondary bg-orange-50"
          : "border rounded-md p-2.5 cursor-pointer hover:bg-gray-50"
      }
    >
      <div className="flex items-center justify-start gap-10">
        <div className="flex items-center gap-3">
          <div
            className={
              isSelected
                ? "w-4 h-4 rounded-md border-2 border-secondary"
                : "w-4 h-4 rounded-md border-2"
            }
          >
            {isSelected ? (
              <TickThinOutline className={"w-3 h-3"} fill="#FF9800" />
            ) : null}
          </div>
          <img
            src={(function () {
              switch (data?.card?.brand.toLowerCase()) {
                case "visa":
                  return VisaCardImg;
                case "mastercard":
                  return MasterCardImg;
                case "amex":
                  return AmericanExpressCardImg;
                case "maestro":
                  return MaestroCardImage;
                default:
                  return VisaCardImg;
              }
            })()}
            alt={data?.card?.brand}
            className="h-6"
          />
          <span className="text-xs text-primary">
            **** **** **** {data?.card?.last4}
          </span>
        </div>
        <div className="flex items-center gap-4">
          <span className="text-xs text-gray-600">
            {data?.card?.exp_month}/{data?.card?.exp_year}
          </span>
          <span className="text-xs text-gray-600">
            {data?.billing_details?.name}
          </span>
        </div>
      </div>
    </div>
  );
};


export default PaymentCard